import React, { useState } from 'react'
import TopNavbar from "../../components/AdminPortal/TopNavbar";
import { useSidebar } from "../../context/SidebarContext";
import Permissions from '../../components/AdminPortal/Permissions';
import SanctionLetterManagement from '../../components/AdminPortal/SanctionLetterManagement'; 
import "../../global.css";
import PayslipManagement from '../../components/AdminPortal/PayslipManagement';

const AdminSettings = () => {
  const { sidebarExpanded, isMobile } = useSidebar();
  const [activeTab, setActiveTab] = useState("permissions");

  return (
    <div
      className="min-h-screen bg-black text-white mt-12"
      style={{
        marginLeft: isMobile ? "0" : sidebarExpanded ? "200px" : "60px",
        width: isMobile
          ? "100%"
          : `calc(100% - ${sidebarExpanded ? "200px" : "60px"})`,
      }}
    >
      <TopNavbar />
      <div className="p-4 md:p-6">
        <div className="tab-strip-border overflow-x-auto scrollbar-hide">
          <div className="flex">
            {/* Permissions Tab */}
            <button
              onClick={() => setActiveTab("permissions")}
              className={`tab-button ${
                activeTab === "permissions"
                  ? "active-tab-border"
                  : "inactive-tab"
              }`}
            >
              Permissions & Configure
            </button>

            {/* Sanction Letter Management Tab */}
            <button
              onClick={() => setActiveTab("sanctionLetters")}
              className={`tab-button ${
                activeTab === "sanctionLetters"
                  ? "active-tab-border"
                  : "inactive-tab"
              }`}
            >
              Sanction Letter Management
            </button>
            <button
              onClick={() => setActiveTab("payslips")}
              className={`tab-button ${
                activeTab === "payslips"
                  ? "active-tab-border"
                  : "inactive-tab"
              }`}
            >
              Payslip Management
            </button>


          </div>
        </div>
      </div>
      
      {/* Tab Content */}
      {activeTab === "permissions" && <Permissions />}
      {activeTab === "sanctionLetters" && <SanctionLetterManagement />}
      {activeTab === "payslips" && <PayslipManagement />}
    </div>
  )
}

export default AdminSettings;
